import 'hammerjs';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { importProvidersFrom } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { appConfig } from './app/app.config';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

async function bootstrap() {
  const response = await fetch('assets/config/environment.json');
  const environment = await response.json();

  // Simulador para probar el modo de producción en local
  const simulateProduction = false; // Cambia a 'true' para simular el comportamiento de producción en local

  // Detectar si estamos en localhost o en el puerto 4200
  const isLocalhost = window.location.hostname === 'localhost';
  const isPort4200 = window.location.port === '4200';

  // Detectar si es entorno de producción o si está simulando producción
  const isProduction = simulateProduction || environment.production;

  // Deshabilitar la consola solo si es producción y no estamos en localhost:4200
  if (isProduction && !(isLocalhost && isPort4200 && !simulateProduction)) {
    // enableProdMode(); // Esta función ya no es necesaria en Angular 19+

    // Sobrescribir los métodos de la consola
    if (window) {
      ['log', 'info', 'warn'].forEach((method) => {
        (window.console as any)[method] = () => {};
      });
    }
  }

  bootstrapApplication(AppComponent, {
    providers: [
      // Fusiona los proveedores de appConfig con los existentes
      ...appConfig.providers, // <--- Añade los proveedores de app.config.ts
      importProvidersFrom(
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
          },
        }),
      ),
    ],
  }).catch((err) => console.error(err));
}

bootstrap();
